import { baseUrl } from '@/config/config'
var axios = require("axios").default;
const localData = (JSON.parse(localStorage.getItem('token')) === null) ? window.location.href = '/' : JSON.parse(localStorage.getItem('token'));
const token = localData.token
export default class System {
    async SystemList() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/user_list`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async ProfileList(data) {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/fetch/${data}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async DistrictList() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/district_by_state/29`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async DesginationList() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/role_list`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async HospitalList() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/view/viewHCRPHospital`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async updateSystem(data) {
        try {
            const response = await axios.post(`${baseUrl}users/update_other_users`, data, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })

            return response.data;
        } catch (error) {
            console.error(error);
            return false;
        }

    };
}